import React, { useState } from 'react'

import { QuestionCircleFilled } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'

import ListPageHeader from '@shared/ListPageHeader'
import UnknownProductsList from '@shared/unknown_products/UnknownProductsList'
import UnknownProductConceptModal from '@shared/unknown_products/UnknownProductConceptModal'

import { unknownProductService } from '@services/admin/unknownProductService'

export default function AdminUnknownProductsList() {
  const { t } = useTranslation()
  const [conceptModalVisible, setConceptModalVisible] = useState(false)

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['products', 'products.unknown']}
        guideButton={
          <Tooltip title={t('concepts.unknown_products.tooltip')}>
            <Button
              type="text"
              size="small"
              icon={<QuestionCircleFilled style={{ color: '#1890ff' }} />}
              onClick={() => setConceptModalVisible(true)}
              style={{ padding: 0, height: 'auto', minWidth: 'auto' }}
            />
          </Tooltip>
        }
      />
      <UnknownProductsList
        role="admin"
        service={unknownProductService}
        showMerchantColumn={false}
      />
      <UnknownProductConceptModal
        visible={conceptModalVisible}
        onClose={() => setConceptModalVisible(false)}
      />
    </div>
  )
}
